import { render, staticRenderFns } from "./WristbandDetailsView.vue?vue&type=template&id=0298e5bd&scoped=true"
import script from "./WristbandDetailsView.vue?vue&type=script&lang=js"
export * from "./WristbandDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298e5bd",
  null
  
)

export default component.exports